export default "__VITE_ASSET__C3I9NA7e__"